import React from 'react'
import config from '../config'

export const Image = (props) => {
  return(
    <div className={'product-image'}>
      <img
        className={props.imageClass ? `${ props.imageClass } product-image` : 'product-image'}
        width={ props.width || '125'} height={ props.height || '125'}
        src={`${props.image_url}`} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Products/image.jsx